import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

export interface FormValues {
  testCollectionName: string;
  testService: string;
  productLine: string;
  productNumber: string;
  productVersion: string;
  testCollectionFile: string;
}

export const defaultValues: FormValues = {
  testCollectionName: '',
  testService: '',
  productLine: '',
  productNumber: '',
  productVersion: '',
  testCollectionFile: ''
};

function setSchema() {
  return yup.object({
    testCollectionName: yup.string().required('Test Collection Name is required'),
    testService: yup.string().when('testCollectionFile', {
      is: (value: string) => { 
        return value.substring(value.lastIndexOf('.')) === '.zip'
       },
      then: (schema) => schema.notRequired(),
      otherwise: (schema) => schema.required('Test Service is required')
    }),
    productLine: yup.string().required('Product Line is required'),
    productNumber: yup.string().required('Product Number is required'),
    productVersion: yup.string().required('Product Version is required'),
    testCollectionFile: yup.string().required('Test Collection File is required')
  });
}

export function useTestCollectionForm() {
  const schema = setSchema();
  return useForm({
    mode: 'onSubmit',
    resolver: yupResolver(schema),
    defaultValues: { ...defaultValues }
  });
}
